import { mapState } from "vuex"
import profile from "@/services/sharedo/profileService";
import organizations from "@/services/sharedo/organizationsService";

const mixin = {
    data: function () {
        return {
            profile: null,
            profileLoaded: false
        }
    },
    computed: {
        ...mapState({
            loggedIn: state => state.loggedIn
        }),
    },
    watch: {
        loggedIn: async function (hasLoggedIn) {
            if (hasLoggedIn) {
                await this.$_profile_loadProfile();
            } else {
                this.profile = null;
                this.profileLoaded = false;
            }
        }
    },
    methods: {
        $_profile_loadProfile: async function () {
            if (this.loggedIn) {
                try {
                    this.profile = await profile.get();
                    this.profileLoaded = true;
                    this.logInfo("Profile loaded.", { profile: this.profile });
                } catch (error) {
                    this.logError("Unable to load profile.", { error });
                }
            }
        },
        getProfileImage: async function () {
            if (this.profile) {
                try {
                    const image = await profile.getImage(this.profile.userId);
                    this.logInfo("Profile image loaded.", { profile: this.profile });
                    return image;
                } catch {
                    this.logWarning("Unable to load profile image.");
                    return null;
                }
            }
        },
        getOrganization: async function () {
            if (this.profile) {
                try {
                    const org = await organizations.getOne(this.profile.organisationId);
                    this.logInfo("Organization loaded.", { org });
                    return org;
                } catch (error) {
                    this.logError("Unable to retrieve organization for user.", { profile: this.profile, error });
                }
            }
        },
        hasPermission: function (permission) {
            if (this.profile) {
                const success = this.profile.globalPermissions.indexOf(permission) > -1;
                if (!success) {
                    this.logWarning("User does not have the required permission.", { profile: this.profile, permission });
                }

                return success;
            }

            return false;
        }
    },
    created: async function () {
        await this.$_profile_loadProfile();
    }
};

export default mixin;